import React from 'react'

const Button = ({ className, label, handleClick, buttonStyle, type, icon, ariaLabel }) => (
  <button
    className={className}
    style={buttonStyle}
    onClick={handleClick}
    type={type}
    aria-label={ariaLabel}
  >
    {label}
    {icon}
  </button>
)

export default Button
